(function () {
  const FREE_SHIPPING = 3500;
  const ROOT = window.Shopify.routes.root;

  function formatMoney(cents) {
    return new Intl.NumberFormat(
      document.documentElement.lang === 'nl' ? 'nl-NL' : 'de-DE',
      {
        style: 'currency',
        currency: 'EUR'
      }
    ).format(cents / 100);
  }

  async function updateCartExtras() {
    const box = document.querySelector('[data-cart-cross-sell]');
    if (!box) return;

    try {
      const cart = await fetch(ROOT + 'cart.js', {
        headers: { Accept: 'application/json' }
      }).then(response => response.json());

      /*
       * KOSTENLOSER VERSAND
       */
      const shippingText = box.querySelector('[data-shipping-text]');
      const shippingProgress = box.querySelector('[data-shipping-progress]');

      const remaining = Math.max(FREE_SHIPPING - cart.total_price, 0);
      const percentage = Math.min(
        (cart.total_price / FREE_SHIPPING) * 100,
        100
      );

      if (shippingText) {
        if (remaining > 0) {
          shippingText.innerHTML =
            'Nur noch <strong>' +
            formatMoney(remaining) +
            '</strong> bis zum kostenlosen Versand';
        } else {
          shippingText.innerHTML =
            '<strong>Kostenloser Versand erreicht</strong>';
        }
      }

      if (shippingProgress) {
  shippingProgress.style.setProperty(
    'width',
    percentage + '%',
    'important'
  );
  shippingProgress.style.setProperty(
  'background',
  '#BE9B50',
  'important'
);
}

      /*
       * CROSS-SELL
       */
      const recommendationBox = box.querySelector(
        '[data-cross-sell-recommendations]'
      );

      const productsBox = box.querySelector(
        '[data-cross-sell-products]'
      );

      if (!cart.items.length || !recommendationBox || !productsBox) {
        return;
      }

      const productId = cart.items[0].product_id;

      const response = await fetch(
        ROOT +
          'recommendations/products.json?product_id=' +
          productId +
          '&limit=3&intent=complementary'
      );

      if (!response.ok) return;

      const data = await response.json();

      const cartProductIds = cart.items.map(
        item => Number(item.product_id)
      );

      const products = (data.products || [])
        .filter(product => !cartProductIds.includes(Number(product.id)))
        .slice(0, 3);

      productsBox.innerHTML = '';

      if (!products.length) {
        recommendationBox.hidden = true;
        return;
      }

      products.forEach(product => {
        const variant =
          product.variants.find(variant => variant.available) ||
          product.variants[0];

        if (!variant) return;

        const item = document.createElement('div');
        item.className = 'cross-sell-product';

        const imageLink = document.createElement('a');
        imageLink.href = product.url;

        if (product.featured_image) {
          const image = document.createElement('img');
          image.className = 'cross-sell-product__image';
          image.src = product.featured_image;
          image.alt = product.title;
          image.loading = 'lazy';
          imageLink.appendChild(image);
        }

        const info = document.createElement('div');
        info.className = 'cross-sell-product__info';

        const title = document.createElement('a');
        title.className = 'cross-sell-product__title';
        title.href = product.url;
        title.textContent = product.title;

        const price = document.createElement('div');
        price.className = 'cross-sell-product__price';
        price.textContent = formatMoney(variant.price);

        info.appendChild(title);
        info.appendChild(price);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cross-sell-product__button';
        button.textContent = 'HINZUFÜGEN';
        button.dataset.variantId = variant.id;

        button.addEventListener('click', function () {
          addProduct(button);
        });

        item.appendChild(imageLink);
        item.appendChild(info);
        item.appendChild(button);

        productsBox.appendChild(item);
      });

      recommendationBox.hidden = false;

    } catch (error) {
      console.error('Cart Cross-Sell:', error);
    }
  }

  async function addProduct(button) {
    const variantId = button.dataset.variantId;

    button.disabled = true;
    button.textContent = '...';

    try {
      const body = new URLSearchParams();

      body.append('items[0][id]', variantId);
      body.append('items[0][quantity]', '1');
      body.append(
        'sections',
        'cart-drawer,cart-icon-bubble'
      );
      body.append(
        'sections_url',
        window.location.pathname
      );

      const response = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: body.toString()
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description || 'Produkt konnte nicht hinzugefügt werden.'
        );
      }

      const cartDrawer = document.querySelector('cart-drawer');

      if (
        cartDrawer &&
        typeof cartDrawer.renderContents === 'function'
      ) {
        cartDrawer.renderContents(data);
      }

    } catch (error) {
      console.error('Cart Cross-Sell Add:', error);

      button.disabled = false;
      button.textContent = 'HINZUFÜGEN';

      alert(
        error.message ||
        'Das Produkt konnte nicht hinzugefügt werden.'
      );
    }
  }

  /*
   * Beim ersten Laden
   */
  document.addEventListener(
    'DOMContentLoaded',
    updateCartExtras
  );

  /*
   * Dawn aktualisiert den Cart Drawer dynamisch.
   * Deshalb prüfen wir nach einer Cart-Aktualisierung erneut.
   */
  document.addEventListener(
    'cart:updated',
    updateCartExtras
  );

  document.addEventListener(
    'cartUpdate',
    updateCartExtras
  );

  /*
   * Falls Dawn den Drawer per Section Rendering
   * komplett neu in den DOM schreibt.
   */
  let lastBox = null;

  const observer = new MutationObserver(function () {
    const box = document.querySelector(
      '[data-cart-cross-sell]'
    );

    if (box && box !== lastBox) {
      lastBox = box;
      setTimeout(updateCartExtras, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();